<template>
  <vue-scroll>
  <div class="guarantee-detail">
    <div class="detail-header">
      <div class="status-badge">
        <Tag color="warning" v-if="renewalNeedAudit">
          续保待审核
        </Tag>
        <Tag :color="$common.guaranteeStatusColor[guaranteeModel.status]">
          {{$common.guaranteeStatus[guaranteeModel.status]}}
        </Tag>
        <Tag v-if="guaranteeModel.gEndDateOri" color="orange">已续保</Tag>
      </div>
      <h2>
        {{guaranteeModel.orderNumber}}
      </h2>
      <Tooltip :content="guaranteeModel.varietyName">
        <Tag :color="getVarietyTagColor(guaranteeModel.variety)">{{guaranteeModel.varietyName||'未知'}}</Tag>
      </Tooltip>
      <Tag :color="guaranteeModel.gMethod===0?'primary':'success'" type="border">{{guaranteeModel.gMethod===0?'独立保证':'联合保证'}}</Tag>
      <div class="header-actions">
        <ButtonGroup style="margin-right:5px;">
          <Button type="default"
            @click="getGuaranteeDetail">
            <Icon type="md-refresh" />
            刷新</Button>
          <Button type="default"
            v-if="checkRolePermitted(['保证人','监管人','总监管人'])
            &&[1,2,4].indexOf(guaranteeModel.status)>-1"
            @click="showGuaReceipt">
            <Icon type="md-download" />
            保函收讫单</Button>
        </ButtonGroup>
        <ButtonGroup>
          <Button type="default"
            v-if="checkRolePermitted('保证人')"
            @click="setRemark">
            <Icon type="ios-chatbubbles-outline" />
            备注(自)</Button>
          <Button type="default"
            v-if="checkRolePermitted('保证人')"
            @click="setGuaranteeRemark">
            <Icon type="ios-bookmark-outline" />
            备注(公开)</Button>
          <Button type="default"
            v-if="checkRolePermitted('保证人')&&(guaranteeModel.status===7||guaranteeModel.status===6)"
            @click="edit">
            <Icon type="md-create" />
            修改</Button>
          <Button type="default"
            v-if="checkRolePermitted('保证人')&&(guaranteeModel.status===7||guaranteeModel.status===6)"
            @click="remove">
            <Icon type="md-trash" />
            删除</Button>
          <Button type="default"
            v-if="getSysConfig('ENABLE_E_GUA')&&checkRolePermitted('保证人')&&!pdfUrl&&guaranteeModel.status!==7&&guaranteeModel.status!==6&&guaranteeModel.status!==3"
            @click="showTemplateDrawer=true">
            <Icon type="md-create" />
            签发</Button>
          <Button type="default"
            v-if="checkRolePermitted('保证人')&&guaranteeModel.status==1"
            @click="terminate">
            <Icon type="md-power" />
            解除</Button>
          <Button type="default"
            v-if="checkRolePermitted('保证人')&&guaranteeModel.status==1&&getSysConfig('GUARANTEE_RENEWAL_ENABLED')"
            @click="showRenewalModal=true">
            <Icon type="md-infinite" />
            续保</Button>
          <Button type="default"
            v-if="checkRolePermitted(['监管人','总监管人'])&&checkSpvMng('canSelfMark')"
            @click="setRemark">
            <Icon type="ios-chatbubbles-outline" />
            备注(自)</Button>
          <Button type="default"
            v-if="checkRolePermitted(['监管人','总监管人'])&&guaranteeModel.status==0&&checkSpvMng('canAudit')"
            @click="auditPass">
            <Icon type="md-checkmark" />
            审核</Button>
          <Button type="default"
            v-if="checkRolePermitted(['监管人','总监管人'])&&guaranteeModel.status==0&&checkSpvMng('canAudit')"
            @click="auditDeny">
            <Icon type="md-close" />
            退回</Button>
          <Button type="default"
            v-if="checkRolePermitted(['监管人','总监管人'])&&guaranteeModel.status==2&&checkSpvMng('canAuditTerminate')"
            @click="auditTerminatePass">
            <Icon type="md-checkmark" />
            审核</Button>
          <Button type="default"
            v-if="checkRolePermitted(['监管人','总监管人'])&&guaranteeModel.status==2&&checkSpvMng('canAuditTerminate')"
            @click="auditTerminateDeny">
            <Icon type="md-close" />
            退回</Button>
          <Button type="default"
            v-if="checkRolePermitted(['监管人','总监管人'])&&guaranteeModel.status==8&&checkSpvMng('canPreAudit')&&getSysConfig('ENABLE_PREAUDIT_GUARANTEE')"
            @click="preAuditPass">
            <Icon type="md-checkmark" />
            预审通过</Button>
          <Button type="default"
            v-if="checkRolePermitted(['监管人','总监管人'])&&guaranteeModel.status==8&&checkSpvMng('canPreAudit')&&getSysConfig('ENABLE_PREAUDIT_GUARANTEE')"
            @click="preAuditDeny">
            <Icon type="md-close" />
            退回</Button>
          <Button type="default"
            v-if="checkRolePermitted(['保证人','监管人','总监管人','管理员'])&&pdfUrl&&guaranteeModel.status!==7&&guaranteeModel.status!==6"
            @click="download">
            <Icon type="md-cloud-download" />
            下载</Button>
          <Button type="default"
            v-if="checkRolePermitted(['保证人','监管人','总监管人','管理员'])&&pdfUrl&&guaranteeModel.status!==7&&guaranteeModel.status!==6"
            @click="revokePdf">
            <Icon type="md-remove-circle" />
            撤销电子保函</Button>
          <Button type="default"
            v-if="getSysConfig('ENABLE_CLAIM')
            &&checkRolePermitted(['监管人','总监管人'])
            &&[1,2,4].indexOf(guaranteeModel.status)>-1
            &&checkSpvMng('canClaim')"
            @click="goToClaim">
            <Icon type="md-cash" />
            发起代偿</Button>
        </ButtonGroup>
      </div>
    </div>
    <div class="detail-body">
      <Tabs type="card" class="tab-square" :animated="false" v-if="guaranteeModel&&guaranteeModel.orderNumber" v-model="curTab">
        <TabPane label="基本信息" name="basic">
          <Alert show-icon v-if="myRemark&&myRemark.remark">
            备注
            <template slot="desc">
              [{{require('moment')(myRemark.updateTime).format('YYYY-MM-DD HH:mm:ss')}}]<br>{{myRemark.remark}}
            </template>
          </Alert>
          <Divider>基本属性</Divider>
          <table class="brief-table">
            <tbody>
              <tr>
                <td class="title">地区</td>
                <td>{{guaranteeModel.cityName}}</td>
                <td class="title">行业/领域</td>
                <td>{{guaranteeModel.industry?guaranteeModel.industry.name:'-'}}</td>
                <td class="title">担保种类</td>
                <td>{{guaranteeModel.varietyName}}</td>
              </tr>
              <tr>
                <td class="title">{{guaranteeModel.gMethod===2?'主':''}}保证人</td>
                <td colspan="3">{{guaranteeModel.guarantor?guaranteeModel.guarantor.name:'-'}}</td>
                <td class="title">社会信用代码</td>
                <td>{{guaranteeModel.guarantor?guaranteeModel.guarantor.businessLicense:'-'}}</td>
              </tr>
              <tr>
                <td class="title">受益人</td>
                <td colspan="3">{{guaranteeModel.beneficiary}}</td>
                <td class="title">社会信用代码</td>
                <td>{{guaranteeModel.beneficiaryBusinessLicense}}</td>
              </tr>
              <tr>
                <td class="title">受益人地址</td>
                <td colspan="5">{{guaranteeModel.beneficiaryAddress}}</td>
              </tr>
              <tr>
                <td class="title">被保证人</td>
                <td colspan="3">{{guaranteeModel.guaranteed}}</td>
                <td class="title">社会信用代码</td>
                <td>{{guaranteeModel.guaranteedBusinessLicense}}</td>
              </tr>
              <tr>
                <td class="title">被保证人地址</td>
                <td colspan="5">{{guaranteeModel.guaranteedAddress}}</td>
              </tr>
              <tr v-if="guaranteeModel.gMethod===2">
                <td class="title">保证方式</td>
                <td>{{guaranteeModel.gMethod===0?'独立保证':'联合保证'}}</td>
                <td class="title">联保方案</td>
                <td colspan="3">
                  <ul class="joint-plan">
                    <li>主承：{{guaranteeModel.guarantor.name}}，{{`¥ ${guaranteeModel.amount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元</li>
                    <li v-for="(j,idx) in guaranteeModel.jointGuarantors" :key="idx">
                      联保{{idx+1}}：{{j.guarantor.name}}，{{`¥ ${j.amount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元
                    </li>
                  </ul>
                </td>
              </tr>
              <tr v-if="guaranteeModel.gMethod===2">
                <td class="title">总担保金额</td>
                <td>{{`¥ ${totalGuaAmount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元({{$common.transformNumberIntoCHS(totalGuaAmount/100)}})</td>
                <td class="title">担保费率(%·月)</td>
                <td>{{guaranteeModel.gFeeRate>0?Math.round(guaranteeModel.gFeeRate*100)/100+'%·月':''}}</td>
                <td class="title">保额造价比</td>
                <td>{{Math.round(guaranteeModel.amountCostRatio*10000)/100}}%</td>
              </tr>
              <tr v-if="guaranteeModel.gMethod===0">
                <td class="title">担保金额</td>
                <td>{{`¥ ${guaranteeModel.amount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元({{$common.transformNumberIntoCHS(guaranteeModel.amount/100)}})</td>
                <td class="title">担保费率(%·月)</td>
                <td>{{guaranteeModel.gFeeRate>0?Math.round(guaranteeModel.gFeeRate*100)/100+'%·月':''}}</td>
                <td class="title">保额造价比</td>
                <td>{{Math.round(guaranteeModel.amountCostRatio*10000)/100}}%</td>
              </tr>
              <tr>
                <td class="title">保费总额</td>
                <td>
                  <span v-if="guaranteeModel.fee">
                    {{`¥ ${guaranteeModel.fee/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元({{$common.transformNumberIntoCHS(guaranteeModel.fee/100)}})
                  </span>
                  <span v-else>-</span>
                </td>
                <td class="title">保函收费起止时间</td>
                <td colspan="3">
                  {{require('moment')(guaranteeModel.gStartDate).format('YYYY-MM-DD HH:mm:ss')}}
                  &nbsp;~&nbsp;
                  {{require('moment')(guaranteeModel.gEndDate).format('YYYY-MM-DD HH:mm:ss')}}
                  ({{require('moment')(guaranteeModel.gEndDate).diff(require('moment')(guaranteeModel.gStartDate), 'days')}}天)
                  <p v-if="guaranteeModel.gEndDateOri">
                    (原始起止时间：{{require('moment')(guaranteeModel.gStartDate).format('YYYY-MM-DD HH:mm:ss')}}
                  &nbsp;~&nbsp;
                  {{require('moment')(guaranteeModel.gEndDateOri).format('YYYY-MM-DD HH:mm:ss')}})
                  </p>
                </td>
              </tr>
              <tr>
                <td class="title">上报人</td>
                <td>{{guaranteeModel.opName}}({{guaranteeModel.opContactTel}})</td>
                <td class="title">最后修改</td>
                <td>{{require('moment')(guaranteeModel.updateTime).format('YYYY-MM-DD HH:mm:ss')}}</td>
                <td class="title">录入时间</td>
                <td>{{require('moment')(guaranteeModel.createTime).format('YYYY-MM-DD HH:mm:ss')}}</td>
              </tr>
              <tr v-if="[0, 1, 2, 3, 4, 5, 8].indexOf(guaranteeModel.status)>-1">
                <td class="title">预审人</td>
                <td>{{guaranteeModel.preAuditorName}}</td>
                <td class="title">预审时间</td>
                <td colspan="3">{{guaranteeModel.preAuditTime?require('moment')(guaranteeModel.preAuditTime).format('YYYY-MM-DD HH:mm:ss'):''}}</td>
              </tr>
              <tr v-if="[0, 1, 2, 3, 4, 5].indexOf(guaranteeModel.status)>-1">
                <td class="title">审核人</td>
                <td>{{guaranteeModel.auditorName}}</td>
                <td class="title">审核时间</td>
                <td :colspan="[3, 4, 5].indexOf(guaranteeModel.status)>-1?1:3">{{guaranteeModel.auditTime?require('moment')(guaranteeModel.auditTime).format('YYYY-MM-DD HH:mm:ss'):''}}</td>
                <td class="title" v-if="[3, 4, 5].indexOf(guaranteeModel.status)>-1">终止时间</td>
                <td v-if="[3, 4, 5].indexOf(guaranteeModel.status)>-1">{{guaranteeModel.terminateTime?require('moment')(guaranteeModel.terminateTime).format('YYYY-MM-DD HH:mm:ss'):''}}</td>
              </tr>
              <tr v-if="guaranteeModel.terminateReason">
                <td class="title">解除保函的原因</td>
                <td colspan="5">{{guaranteeModel.terminateReason}}</td>
              </tr>
              <tr v-if="[6].indexOf(guaranteeModel.status)>-1&&guaranteeModel.auditReason">
                <td class="title">审核拒绝的原因</td>
                <td colspan="5">{{guaranteeModel.auditReason}}</td>
              </tr>
              <tr v-if="[0, 6].indexOf(guaranteeModel.status)>-1&&guaranteeModel.preAuditReason">
                <td class="title">预审拒绝的原因</td>
                <td colspan="5">{{guaranteeModel.preAuditReason}}</td>
              </tr>
            </tbody>
          </table>
          <div class="padding-top-20"></div>
          <Divider>反担保信息</Divider>
          <table class="brief-table">
            <tbody>
              <tr>
                <td class="title">反担保总额</td>
                <td>{{guaranteeModel.counterCash>0?(guaranteeModel.counterCash+guaranteeModel.counterMortgage+guaranteeModel.counter3rdparty+guaranteeModel.counterOther)/100+'元':''}}{{guaranteeModel.counterCash>0?'('+$common.transformNumberIntoCHS((guaranteeModel.counterCash+guaranteeModel.counterMortgage+guaranteeModel.counter3rdparty+guaranteeModel.counterOther)/100)+')':''}}</td>
                <td class="title">反担保比例</td>
                <td>{{guaranteeModel.counterRatio>0?Math.round(guaranteeModel.counterRatio*10000)/100+'%':''}}</td>
                <td class="title">现金反担保</td>
                <td>{{guaranteeModel.counterCash>0?guaranteeModel.counterCash/100+'元':''}}{{guaranteeModel.counterCash>0?'('+$common.transformNumberIntoCHS(guaranteeModel.counterCash/100)+')':''}}</td>
              </tr>
              <tr>
                <td class="title">抵押质押</td>
                <td>{{guaranteeModel.counterMortgage>0?guaranteeModel.counterMortgage/100+'元':''}}{{guaranteeModel.counterMortgage>0?'('+$common.transformNumberIntoCHS(guaranteeModel.counterMortgage/100)+')':''}}</td>
                <td class="title">第三方反担保</td>
                <td>{{guaranteeModel.counter3rdparty>0?guaranteeModel.counter3rdparty/100+'元':''}}{{guaranteeModel.counter3rdparty>0?'('+$common.transformNumberIntoCHS(guaranteeModel.counter3rdparty/100)+')':''}}</td>
                <td class="title">其他反担保</td>
                <td>{{guaranteeModel.counterOther>0?guaranteeModel.counterOther/100+'元':''}}{{guaranteeModel.counterOther>0?'('+$common.transformNumberIntoCHS(guaranteeModel.counterOther/100)+')':''}}</td>
              </tr>
            </tbody>
          </table>
        </TabPane>
        <TabPane label="项目信息" name="project" v-if="guaranteeModel.project">
          <Divider>项目详情</Divider>
          <table class="brief-table">
            <tbody>
              <tr>
                <td class="title">项目名称</td>
                <td>{{guaranteeModel.project.name}}</td>
                <td class="title">项目类型</td>
                <td>{{getPrjType(guaranteeModel.project.type).join('/')}}</td>
                <td class="title">土地使用证编号</td>
                <td>{{guaranteeModel.project.landLicenceNo||'-'}}</td>
              </tr>
              <tr>
                <td class="title">项目立项备案号</td>
                <td>{{guaranteeModel.project.filingNo||'-'}}</td>
                <td class="title">规划许可证号</td>
                <td>{{guaranteeModel.project.planLicenseNo||'-'}}</td>
                <td class="title">施工许可证号</td>
                <td>{{guaranteeModel.project.constrLicenceNo||'-'}}</td>
              </tr>
              <tr>
                <td class="title">工程造价</td>
                <td>{{`¥ ${guaranteeModel.project.cost/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元({{$common.transformNumberIntoCHS(guaranteeModel.project.cost/100)}})</td>
                <td class="title">建设规模</td>
                <td>{{guaranteeModel.project.area||'-'}}</td>
                <td class="title">计划工期</td>
                <td>
                  {{guaranteeModel.project.startdate?require('moment')(guaranteeModel.project.startdate).format('YYYY/MM/DD'):null}}
                  -
                  {{guaranteeModel.project.finishdate?require('moment')(guaranteeModel.project.finishdate).format('YYYY/MM/DD'):null}}
                  <span v-if="guaranteeModel.project.startdate&&guaranteeModel.project.finishdate">({{guaranteeModel.project.duration}}天)</span>
                </td>
              </tr>
              <tr>
                <td class="title">质量要求</td>
                <td colspan="5">{{guaranteeModel.project.qualityRequirement||'-'}}</td>
              </tr>
            </tbody>
          </table>
          <div class="padding-top-20"></div>
          <Divider>业主详情</Divider>
          <table class="brief-table">
            <tbody>
              <tr>
                <td class="title">业主名称</td>
                <td colspan="3">{{guaranteeModel.owner?guaranteeModel.owner.name:'-'}}</td>
                <td class="title">社会信用代码</td>
                <td>{{guaranteeModel.owner?guaranteeModel.owner.businessLicense:'-'}}</td>
              </tr>
              <tr>
                <td class="title">法人</td>
                <td>{{guaranteeModel.owner?guaranteeModel.owner.legalPersonName:'-'}}</td>
                <td class="title">营业地址</td>
                <td>{{guaranteeModel.owner?guaranteeModel.owner.address:'-'}}</td>
                <td class="title">所在地</td>
                <td>{{guaranteeModel.owner?guaranteeModel.owner.regCity:'-'}}</td>
              </tr>
              <tr>
                <td class="title">联系人</td>
                <td>{{guaranteeModel.owner?guaranteeModel.owner.contact:'-'}}</td>
                <td class="title">联系电话</td>
                <td>{{guaranteeModel.owner?guaranteeModel.owner.contactTel:'-'}}</td>
                <td class="title">电子邮件</td>
                <td>{{guaranteeModel.owner?guaranteeModel.owner.email:'-'}}</td>
              </tr>
            </tbody>
          </table>
          <div class="padding-top-20"></div>
          <Divider>承包商详情</Divider>
          <table class="brief-table">
            <tbody>
              <tr>
                <td class="title">总承包商名称</td>
                <td colspan="3">{{guaranteeModel.contractor?guaranteeModel.contractor.name:'-'}}</td>
                <td class="title">社会信用代码</td>
                <td>{{guaranteeModel.contractor?guaranteeModel.contractor.businessLicense:'-'}}</td>
              </tr>
              <tr>
                <td class="title">总承包合同备案号</td>
                <td>{{guaranteeModel.contractorContractNo}}</td>
                <td class="title">法人</td>
                <td>{{guaranteeModel.contractor?guaranteeModel.contractor.legalPersonName:'-'}}</td>
                <td class="title">所在地</td>
                <td>{{guaranteeModel.contractor?guaranteeModel.contractor.regCity:'-'}}</td>
              </tr>
              <tr>
                <td class="title">营业地址</td>
                <td>{{guaranteeModel.contractor?guaranteeModel.contractor.address:'-'}}</td>
                <td class="title">联系人</td>
                <td>{{guaranteeModel.contractor?guaranteeModel.contractor.contact:'-'}}</td>
                <td class="title">联系电话</td>
                <td>{{guaranteeModel.contractor?guaranteeModel.contractor.contactTel:'-'}}</td>
              </tr>
            </tbody>
          </table>
          <div class="padding-top-20"></div>
          <Divider>监理企业详情</Divider>
          <table class="brief-table">
            <tbody>
              <tr>
                <td class="title">监理企业名称</td>
                <td colspan="3">{{guaranteeModel.supervisory?guaranteeModel.supervisory.name:'-'}}</td>
                <td class="title">社会信用代码</td>
                <td>{{guaranteeModel.supervisory?guaranteeModel.supervisory.businessLicense:'-'}}</td>
              </tr>
              <tr>
                <td class="title">监理合同备案号</td>
                <td>{{guaranteeModel.supervisoryContractNo}}</td>
                <td class="title">法人</td>
                <td>{{guaranteeModel.supervisory?guaranteeModel.supervisory.legalPersonName:'-'}}</td>
                <td class="title">所在地</td>
                <td>{{guaranteeModel.supervisory?guaranteeModel.supervisory.regCity:'-'}}</td>
              </tr>
              <tr>
                <td class="title">营业地址</td>
                <td>{{guaranteeModel.supervisory?guaranteeModel.supervisory.address:'-'}}</td>
                <td class="title">联系人</td>
                <td>{{guaranteeModel.supervisory?guaranteeModel.supervisory.contact:'-'}}</td>
                <td class="title">联系电话</td>
                <td>{{guaranteeModel.supervisory?guaranteeModel.supervisory.contactTel:'-'}}</td>
              </tr>
            </tbody>
          </table>
          <div class="padding-top-20"></div>
          <Divider>劳务分包详情</Divider>
          <table class="brief-table">
            <tbody>
              <tr>
                <td class="title">劳务分包负责人</td>
                <td>{{guaranteeModel.distributorIncharge}}</td>
                <td class="title">身份证号</td>
                <td>{{guaranteeModel.distributorInchargeId}}</td>
                <td class="title">劳务分包合同备案号</td>
                <td>{{guaranteeModel.distributorContractNo}}</td>
              </tr>
              <tr>
                <td class="title">联系人</td>
                <td>{{guaranteeModel.distributorContact}}</td>
                <td class="title">联系电话</td>
                <td>{{guaranteeModel.distributorTel}}</td>
                <td class="title"></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </TabPane>
        <TabPane label="保函附件" name="attachments"
          v-if="(contractOssKeys&&contractOssKeys instanceof Array&&contractOssKeys.length)
            ||(reportOssKeys&&reportOssKeys instanceof Array&&reportOssKeys.length)
            ||(attachments&&attachments instanceof Array&&attachments.length)">
          <section>
            <Divider>担保合同</Divider>
            <div class="contract">
              <!-- <div class="contract-thumb"
                @click="previewImgUrl=img;showPreview=true"
                :key="idx"
                v-for="(img,idx) in contractOssKeys">
                <img :src="img.url" v-if="img&&img.url&&img.type==='image'">
                <span style="font-weight:bold;color:#999" v-if="img&&img.url&&img.type==='file'">{{img.surfix.toUpperCase()}}</span>
              </div> -->
              <div class="contract-thumb"
                :key="idx"
                v-for="(img,idx) in contractOssKeys">
                <img :src="img.url" @click="handleImgPreview(contractOssKeys, idx)" v-if="img&&img.url&&img.type==='image'">
                <span style="font-weight:bold;color:#999;padding:10px;cursor:pointer" v-if="img&&img.url&&img.type==='file'" @click="previewImgUrl=img;showPreview=true">{{img.surfix.toUpperCase()}}</span>
              </div>
            </div>
            <div class="padding-top-20"></div>
          </section>
          <section v-if="reportOssKeys&&reportOssKeys instanceof Array&&reportOssKeys.length">
            <Divider>竣工手续</Divider>
            <div class="contract">
              <!-- <div class="contract-thumb"
                @click="previewImgUrl=img;showPreview=true"
                :key="idx"
                v-for="(img,idx) in uploadedReportArray">
                <img :src="img.url" v-if="img&&img.url&&img.type==='image'">
                <span style="font-weight:bold;color:#999" v-if="img&&img.url&&img.type==='file'">{{img.surfix.toUpperCase()}}</span>
              </div> -->
              <div class="contract-thumb"
                :key="idx"
                v-for="(img,idx) in uploadedReportArray">
                <img :src="img.url" @click="handleImgPreview(uploadedReportArray, idx)" v-if="img&&img.url&&img.type==='image'">
                <span style="font-weight:bold;color:#999;padding:10px;cursor:pointer" v-if="img&&img.url&&img.type==='file'" @click="previewImgUrl=img;showPreview=true">{{img.surfix.toUpperCase()}}</span>
              </div>
            </div>
            <div class="padding-top-20"></div>
          </section>
          <section v-if="attachments&&attachments instanceof Array&&attachments.length">
            <div v-for="(att,idx) in attachments" :key="idx">
              <Divider>{{att.name}}</Divider>
              <div class="contract">
                <!-- <div class="contract-thumb"
                  @click="previewImgUrl=img;showPreview=true"
                  :key="idx"
                  v-for="(img,idx) in att.ossKeys">
                  <img :src="img.url" v-if="img&&img.url&&img.type==='image'">
                  <span style="font-weight:bold;color:#999" v-if="img&&img.url&&img.type==='file'">{{img.surfix.toUpperCase()}}</span>
                </div> -->
                <div class="contract-thumb"
                  :key="idx"
                  v-for="(img,idx) in att.ossKeys">
                  <img :src="img.url" @click="handleImgPreview(att.ossKeys, idx)" v-if="img&&img.url&&img.type==='image'">
                  <span style="font-weight:bold;color:#999;padding:10px;cursor:pointer" v-if="img&&img.url&&img.type==='file'" @click="previewImgUrl=img;showPreview=true">{{img.surfix.toUpperCase()}}</span>
                </div>
              </div>
            </div>
          </section>
        </TabPane>
        <TabPane :label="renewalLabel" name="renewals" v-if="renewals instanceof Array&&renewals.length">
          <table class="brief-table">
            <thead>
              <tr>
                <th>申请日期</th>
                <th>续保截止时间</th>
                <th>审核状态</th>
                <th>审核人</th>
                <th>审核时间</th>
                <th>附件</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(renew,renewIdx) in renewals" :key="renewIdx">
                <td>{{$moment(renew.createTime).format('YYYY-MM-DD HH:mm:ss')}}</td>
                <td>{{$moment(renew.renewalEnddate).format('YYYY-MM-DD HH:mm:ss')}}</td>
                <td>
                  <Tag :color="$common.guaranteeRenewalStatusColor[renew.status]">
                    {{$common.guaranteeRenewalStatus[renew.status]}}
                  </Tag>
                  <div class="font-grey small" v-if="renew.status===2">原因：{{renew.auditReason}}</div>
                </td>
                <td>{{renew.auditorName}}</td>
                <td>{{renew.auditTime?$moment(renew.auditTime).format('YYYY-MM-DD HH:mm:ss'):''}}</td>
                <td>
                  <div class="renewal-attachments" v-if="renew.attachments&&renew.attachments instanceof Array&&renew.attachments.length">
                    <div class="renewal-attachment" v-for="(att,attIdx) in renew.attachments" :key="attIdx">
                      <span class="att-title">{{att.name}}:</span>
                      <span class="att-link" v-for="(u, uIdx) in att.url.split(',')" :key="uIdx">
                        <Button type="text" @click="downloadOssFile(u)">下载</Button>
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <Button type="primary" ghost
                    v-if="checkRolePermitted(['监管人','总监管人'])&&guaranteeModel.status==1&&checkSpvMng('canAuditRenewal')&&renew.status==0"
                    @click="auditRenewalPass(renew.tid)">
                    <Icon type="md-checkmark" />
                    审核</Button>
                  <Button type="error" ghost
                    style="margin-left:5px;"
                    v-if="checkRolePermitted(['监管人','总监管人'])&&guaranteeModel.status==1&&checkSpvMng('canAuditRenewal')&&renew.status==0"
                    @click="auditRenewalDeny(renew.tid)">
                    <Icon type="md-close" />
                    拒绝</Button>
                </td>
              </tr>
            </tbody>
          </table>
        </TabPane>
        <TabPane label="备注" name="remarks" v-if="guaranteeModel.remarks">
          {{guaranteeModel.remarks}}
        </TabPane>
      </Tabs>
    </div>
    <div class="padding-top-20"></div>
    <Row :gutter="16" style="margin-bottom:20px;" v-if="checkRolePermitted(['监管人','总监管人'])&&guaranteeModel.status==0&&checkSpvMng('canAudit')">
      <i-col span="12">
        <Button type="primary"
          long size="large"
          @click="auditPass">
          <Icon type="md-checkmark" />
          审核</Button>
      </i-col>
      <i-col span="12">
        <Button type="error"
          long size="large"
          @click="auditDeny">
          <Icon type="md-close" />
          退回</Button>
      </i-col>
    </Row>
    <Row :gutter="16" style="margin-bottom:20px;" v-if="checkRolePermitted(['监管人','总监管人'])&&guaranteeModel.status==8&&checkSpvMng('canPreAudit')&&getSysConfig('ENABLE_PREAUDIT_GUARANTEE')">
      <i-col span="12">
        <Button type="primary"
          long size="large"
          @click="preAuditPass">
          <Icon type="md-checkmark" />
          预审通过</Button>
      </i-col>
      <i-col span="12">
        <Button type="error"
          long size="large"
          @click="preAuditDeny">
          <Icon type="md-close" />
          退回</Button>
      </i-col>
    </Row>
    <Row :gutter="16" style="margin-bottom:20px;" v-if="checkRolePermitted(['监管人','总监管人'])&&guaranteeModel.status==2&&checkSpvMng('canAuditTerminate')">
      <i-col span="12">
        <Button type="primary"
          long size="large"
          @click="auditTerminatePass">
          <Icon type="md-checkmark" />
          审核通过解除请求</Button>
      </i-col>
      <i-col span="12">
        <Button type="error"
          long size="large"
          @click="auditTerminateDeny">
          <Icon type="md-close" />
          退回解除请求</Button>
      </i-col>
    </Row>
    <Button type="warning"
      style="margin-bottom:20px;"
      v-if="getSysConfig('ENABLE_E_GUA')&&checkRolePermitted('保证人')&&!pdfUrl&&guaranteeModel.status!==7&&guaranteeModel.status!==6&&guaranteeModel.status!==3"
      long size="large"
      @click="showTemplateDrawer=true">
      <Icon type="md-create" />
      签发保函
    </Button>
    <Button type="success"
      style="margin-bottom:20px;"
      v-if="checkRolePermitted(['保证人','监管人','总监管人','管理员'])&&pdfUrl&&guaranteeModel.status!==7&&guaranteeModel.status!==6"
      long size="large"
      @click="download">
      <Icon type="md-cloud-download" />
      下载电子保函
    </Button>
    <CertSelectModal
      :show="showCertSelectModal"
      :dataSigning="dataToSign"
      :mode="signMode"
      @cert-verified="certSigned"
      :callback="signCallback"
      @close-modal="showCertSelectModal=false" />
    <SelectTemplateDrawer
      :show="showTemplateDrawer"
      :guaranteeModel="guaranteeModel"
      @on-confirm="startSign"
      @on-close-drawer="showTemplateDrawer=false" />
    <Modal v-model="showPreview" title="查看附件" @on-cancel="showPreview=false;previewImgUrl=null" width="1200">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <iframe :src="getPdfPreviewUrl(previewImgUrl.url)" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'&&previewImgUrl.surfix==='pdf'" width="100%" height="800"></iframe>
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'&&previewImgUrl.surfix!='pdf'">查看</a>
    </Modal>
    <Modal v-model="terminateModal" title="申请解除保函" @on-cancel="closeTerminateModal">
      <Form ref="terminateForm" :model="terminateModel" label-position="left">
        <FormItem
          prop="reason"
          :rules="{required: true, message: '请填写申请解除的原因', trigger: 'blur'}">
          <div class="reasons">
            <span class="reason-selection"
              :class="{selected:selectedReasonIdx===idx}"
              @click="selectReason(idx)"
              v-for="(r,idx) in terminateReasons"
              :key="idx">
              {{r}}
            </span>
          </div>
          <Input v-model="terminateModel.reason"
            type="textarea"
            :disabled="selectedReasonIdx!==null"
            :autosize="{minRows: 5,maxRows: 10}"
            placeholder="输入申请解除的原因..." />
        </FormItem>
        <FormItem label="附件" prop="reportOssKeys" v-if="getSysConfig('NEED_TERMINATE_UPLOAD_REPORT')"
          :rules="[{required:true,validator:arrayValidator,trigger:'change'}]">
          <Upload
            ref="reportUploader"
            :data="OSSParam"
            :before-upload="handleBeforeUpload"
            :multiple="false"
            :on-success="handleUploadSuccess"
            :format="['jpg','jpeg','pdf','png']"
            :on-format-error="handleFormatError"
            :default-file-list="uploadedReportArray"
            :show-upload-list="false"
            :action="uploadParams.host">
            <Poptip trigger="hover" placement="right">
              <Button @click="getOSSParams(1)"><Icon type="ios-cloud-upload-outline"></Icon>上传竣工验收报告</Button>
              <div slot="content">
                <p>上传竣工验收报告</p>
              </div>
            </Poptip>
          </Upload>
          <div class="contract">
            <div class="contract-thumb" v-for="(item,upIdx) in terminateModel.reportOssKeys" :key="upIdx">
              <template v-if="item.status === 'finished'">
                <img :src="item.url">
                <div class="contract-thumb-cover">
                  <Icon type="ios-eye-outline" @click="previewImgUrl=item.url;showPreview=true"></Icon>
                  <Icon type="ios-trash-outline" @click="removeItem(item)"></Icon>
                </div>
              </template>
              <template v-else>
                <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
              </template>
            </div>
          </div>
        </FormItem>
      </Form>
      <div slot="footer">
        <Poptip
          confirm
          title="您确认申请解除该保函么？"
          @on-ok="doTerminateGuarantee">
          <Button type="error"
            v-if="checkRolePermitted('保证人')&&guaranteeModel.status==1">
            提交
          </Button>
        </Poptip>
        <Button type="default" @click="closeTerminateModal" style="margin-left:5px">
          取消
        </Button>
      </div>
    </Modal>
    <SmsVerify :show="showSmsVerify" :mobile="$store.getters.userInfo.mobile" @on-submit="smsVerifySumbit" />
    <image-preview
      :minScale="1"
      :image-urls="imageUrls"
      :visible.sync="visiblePreviewer"
      :start-position="startPosition"></image-preview>
    <RenewalModal
      :show="showRenewalModal"
      :guarantee="guaranteeModel"
      @close="showRenewalModal=false"
      @success="renewSubmitted"
      />
    <ReceiptModal
      :show="showReceiptModal"
      :guarantee="guaranteeModel"
      @close="showReceiptModal=false"
      />
  </div>
  </vue-scroll>
</template>

<script>
// import configs from './../../../configs'
import Api from './../../api/Api.js'
import CertSelectModal from './../../components/CertSelectModal'
import SelectTemplateDrawer from './../../components/SelectTemplateDrawer'
import SmsVerify from './../../components/SmsVerifier/SmsVerifier'
import RenewalModal from './RenewalModal.vue'
import ReceiptModal from './ReceiptModal.vue'

export default {
  name: 'guarantee-detail',
  props: {
  },
  components: {
    CertSelectModal,
    SelectTemplateDrawer,
    SmsVerify,
    RenewalModal,
    ReceiptModal
  },
  data () {
    return {
      loading: false,
      curTab: 'basic',
      guaranteeModel: {
        orderNumber: null,
        myRemark: null,
        remarks: null
      },
      contractOssKeys: [],
      reportOssKeys: [],
      attachments: [],
      supvPerms: {
        canAudit: false,
        canPreAudit: false,
        canAuditTerminate: false,
        canAuditRenewal: false,
        canClaim: false
      },
      renewals: [],
      prjTypes: [],
      guaTypes: [],
      showCertSelectModal: false,
      showTemplateDrawer: false,
      dataToSign: null,
      pdfId: null,
      pdfUrl: null,
      permitted: false,
      signMode: 'bin',
      signCallback: null,
      auditModel: {
        orderNumber: this.$route.params.orderNumber,
        pass: true,
        reason: null
      },
      imgUrl: null,
      previewImgUrl: null,
      showPreview: false,
      terminateModal: false,
      terminateModel: {
        orderNumber: null,
        reason: null,
        reportOssKeys: []
      },
      uploadParams: {
        accessid: '',
        host: '',
        policy: '',
        signature: '',
        callbackbody: '',
        key: '',
        expire: 0
      },
      OSSParams: [],
      OSSParam: {
        name: '',
        key: '',
        policy: '',
        OSSAccessKeyId: '',
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: '',
        fileIndex: 0
      },
      terminateReasons: [
        '履约结束', '业主原因'
      ],
      selectedReasonIdx: null,
      uploadList: [],
      uploadedReportArray: [],
      showSmsVerify: false,
      myRemark: null,
      tempRemark: null,
      visiblePreviewer: false,
      imageUrls: [],
      startPosition: 0,
      showRenewalModal: false,
      showReceiptModal: false,
      pdfjsViewerUrl: null // '/pdfjs/viewer.html'
    }
  },
  watch: {
    '$route.params.orderNumber': function () {
      this.getGuaranteeDetail()
    }
  },
  computed: {
    renewalNeedAudit () {
      if (this.renewals instanceof Array) {
        return this.renewals.findIndex(o => o.status === 0) > -1
      }
      return false
    },
    totalGuaAmount () {
      let mainAmount = this.guaranteeModel.amount
      let jointAmount = 0
      this.guaranteeModel.jointGuarantors.forEach((j) => {
        jointAmount += j.amount
      })
      return mainAmount + jointAmount
    }
  },
  mounted () {
    this.getGuaranteeDetail()
    this.checkViewPermission()
    this.initPrjTypes()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getConfigFromServer (key) {
      return new Promise((resolve, reject) => {
        this.$Api.KVS.getKVS(key).then((res) => {
          let configsStr = res
          resolve(configsStr)
        }).catch(err => {
          this.$Message.error('获取配置失败!' + err.message)
          reject(err)
        })
      })
    },
    getPdfPreviewUrl (fileUrl) {
      if (this.pdfjsViewerUrl) {
        return `${this.pdfjsViewerUrl}?file=${encodeURIComponent(fileUrl)}`
      } else {
        return fileUrl
      }
    },
    getSysConfig (key) {
      return this.$store.getters.sysConfigs[key]
      // return configs(key)
    },
    arrayValidator (rule, value, callback) {
      if (!value || !(value instanceof Array) || !value.length) {
        callback(new Error('没有元素'))
      } else {
        callback()
      }
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1 && this.permitted
      }
      return roles == userRole && this.permitted
    },
    checkSpvMng (action) {
      if (this.$store.getters.userInfo && this.$store.getters.userInfo.type === 127) {
        return true
      }
      if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '总监管人') {
        if (action === 'canClaim') {
          return this.getSysConfig('ENABLE_GEN_SUPV_CLAIM_GUA')
        }
        return this.getSysConfig('ENABLE_GEN_SUPV_MNG_GUA')
      }
      if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '监管人') {
        // return this.getSysConfig('ENABLE_SUPV_MNG_GUA')
        return this.supvPerms[action]
      }
      return false
    },
    getPrjType (type) {
      let prjType
      if (!this.prjTypes.length) {
        this.initPrjTypes().then((types) => {
          prjType = types.find(o => o.tid === parseInt(type))
        })
      } else {
        prjType = this.prjTypes.find(o => o.tid === parseInt(type))
      }
      if (prjType) {
        let prjTypeCur = [prjType.prjType]
        if (prjType.parentNode) {
          let parentNode = this.prjTypes.find(o => o.tid === prjType.parentNode)
          prjTypeCur.splice(0, 0, parentNode.prjType)
        }
        return prjTypeCur
      } else {
        return []
      }
    },
    async initPrjTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Project.getPrjTypes().then(res => {
          this.prjTypes = res
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    getVarietyTagColor (varietyId) {
      return this.$common.guaranteeVarietyColor[varietyId]
    },
    getGuaranteeDetail () {
      this.$Spin.show()
      this.attachments = []
      this.contractOssKeys = []
      this.reportOssKeys = []
      Api.Guarantee.getGuaranteeDetail(this.$route.params.orderNumber).then(async (res) => {
        this.$Spin.hide()
        this.$Message.success('刷新成功!')
        this.guaranteeModel = {
          remarks: null
        }
        Object.assign(this.guaranteeModel, res)
        if (this.guaranteeModel.owner && this.guaranteeModel.owner.regCity) {
          this.guaranteeModel.owner.regCity = await this.getCityName(this.guaranteeModel.owner.regCity)
        }
        if (this.guaranteeModel.contractor && this.guaranteeModel.contractor.regCity) {
          let cityName = await this.getCityName(this.guaranteeModel.contractor.regCity)
          console.log(cityName)
          this.guaranteeModel.contractor.regCity = cityName
        }
        if (this.guaranteeModel.supervisory && this.guaranteeModel.supervisory.regCity) {
          this.guaranteeModel.supervisory.regCity = await this.getCityName(this.guaranteeModel.supervisory.regCity)
        }
        if (this.checkRolePermitted(['监管人','总监管人'])) {
          this.getSupervisionPermission()
        }
        this.getGuaranteeRenewals()
        this.getMyRemark()
        this.getPdfUrl()
        this.procOssKeys(this.guaranteeModel.contractOssKeys)
        this.procReportOssKeys(this.guaranteeModel.reportOssKeys)
        this.procAttachmentsOssKeys(this.guaranteeModel.attachments)
      }).catch(err => {
        this.$Spin.hide()
        this.$Message.error('获取详情失败!' + err.message)
      })
    },
    getCityName (cityId) {
      return new Promise((resolve) => {
        Api.City.getCityName(cityId).then((res) => {
          resolve(res)
        })
      })
    },
    async getGuaranteeRenewals () {
      return new Promise((resolve, reject) => {
        Api.Guarantee.getGuaranteeRenewals(this.guaranteeModel.id).then(res => {
          this.renewals = []
          res.forEach((r) => {
            if (r.attachments) {
              try {
                let attachments = JSON.parse(r.attachments)
                attachments.forEach((a) => {
                  if (a.Url) {
                    a.Url = a.Url.split(',')
                  } else {
                    a.Url = []
                  }
                })
                r.attachments = attachments
              } catch (err) {
                console.log(err)
              }
            }
            this.renewals.push(r)
          })
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    renewalLabel (h) {
      if (this.renewalNeedAudit) {
        return h('Badge', {
          props: {
            dot: true
          }
        }, [
          h('span', '续保记录')
        ])
      } else {
        return h('span', '续保记录')
      }
    },
    getMyRemark () {
      Api.Guarantee.getMyRemark(this.$route.params.orderNumber).then((res) => {
        this.$nextTick(() => {
          this.myRemark = res
        })
      })
    },
    setRemark () {
      if (this.myRemark && this.myRemark.remark) {
        this.tempRemark = this.myRemark.remark
      }
      this.$Modal.confirm({
        title: '备注内容(自己可见)',
        render: (h) => {
          return h('Input', {
            props: {
              value: this.tempRemark,
              autofocus: true,
              placeholder: '备注内容',
              maxlength: '500',
              showWordLimit: true,
              type: 'textarea',
              autosize: {minRows: 5, maxRows: 10},
              rows: 5
            },
            on: {
              input: (val) => {
                this.tempRemark = val
              }
            }
          })
        },
        onOk: () => {
          this.$Spin.show()
          Api.Guarantee.setRemark(this.$route.params.orderNumber, this.tempRemark).then(() => {
            this.$Spin.hide()
            this.$Message.success('备注成功!')
            if (!this.myRemark) {
              this.myRemark = {
                remark: this.tempRemark,
                guaranteeId: this.guaranteeModel.id,
                updateTime: require('moment')().format('YYYY-MM-DD HH:mm:ss')
              }
            }
            this.getMyRemark()
          }).catch(err => {
            this.$Spin.hide()
            this.$Message.error('备注失败!' + err.message)
          })
        },
        onCancel: () => {
          this.tempRemark = null
        }
      })
    },
    setGuaranteeRemark () {
      if (this.guaranteeModel.remarks) {
        this.tempRemark = this.guaranteeModel.remarks
      }
      this.$Modal.confirm({
        title: '备注内容(公开)',
        render: (h) => {
          return h('Input', {
            props: {
              value: this.tempRemark,
              autofocus: true,
              placeholder: '备注内容(公开)',
              maxlength: '500',
              showWordLimit: true,
              type: 'textarea',
              autosize: {minRows: 5, maxRows: 10},
              rows: 5
            },
            on: {
              input: (val) => {
                this.tempRemark = val
              }
            }
          })
        },
        onOk: () => {
          this.$Spin.show()
          Api.Guarantee.setGuaranteeRemark(this.$route.params.orderNumber, this.tempRemark).then(() => {
            this.$Spin.hide()
            this.$Message.success('备注成功!')
            this.guaranteeModel.remarks = this.tempRemark
            this.tempRemark = null
          }).catch(err => {
            this.$Spin.hide()
            this.$Message.error('备注失败!' + err.message)
          })
        },
        onCancel: () => {
          this.tempRemark = null
        }
      })
    },
    async downloadOssFile (k) {
      if (!k) {
        return false
      }
      let url = await this.procOSSUrl(k)
      window.open(url, '_blank')
    },
    async procOssKey (k) {
      try {
        if (!k) {
          return false
        }
        let url = await this.procOSSUrl(k)
        let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
        if (surfix.indexOf('?') > -1) {
          surfix = surfix.substring(0, surfix.indexOf('?'))
        }
        let type = 'image'
        switch (surfix) {
          case 'jpg':
            type = 'image'
            break
          case 'jpeg':
            type = 'image'
            break
          case 'png':
            type = 'image'
            break
          case 'gif':
            type = 'image'
            break
          case 'pdf':
            type = 'file'
            break
          case 'doc':
            type = 'file'
            break
          case 'docx':
            type = 'file'
            break
          case 'xls':
            type = 'file'
            break
          case 'xlsx':
            type = 'file'
            break
          case 'ppt':
            type = 'file'
            break
          case 'pptx':
            type = 'file'
            break
          default:
            type = 'file'
            break
        }
        return {
          name: k,
          url,
          type,
          surfix
        }
      } catch (e) {
        console.log(e)
        return false
      }
    },
    procAttachmentsOssKeys (attaches) {
      this.attachments = []
      attaches.forEach((att) => {
        att.ossKeys = []
        if (att.url) {
          if (att.url.indexOf(',') === 0) {
            att.url = att.url.substr(1)
          }
          let keys = att.url.split(',')
          let ossKeys = []
          keys.forEach(async (k, idx) => {
            att.ossKeys[idx] = await this.procOssKey(k)
            ossKeys.push(att.ossKeys[idx])
          })
        }
        this.attachments.push(att)
      })
    },
    procOssKeys (keys) {
      this.contractOssKeys = []
      keys.forEach(async (k, idx) => {
        let newKey = await this.procOssKey(k)
        this.$nextTick(() => {
          if (typeof(this.guaranteeModel.contractOssKeys[idx]) === 'string') {
            this.guaranteeModel.contractOssKeys[idx] = {}
          }
          this.$set(this.guaranteeModel.contractOssKeys[idx], 'name', newKey.name)
          this.$set(this.guaranteeModel.contractOssKeys[idx], 'url', newKey.url)
          this.$set(this.guaranteeModel.contractOssKeys[idx], 'type', newKey.type)
          this.$set(this.guaranteeModel.contractOssKeys[idx], 'surfix', newKey.surfix)
          this.contractOssKeys.push(newKey)
          // this.guaranteeModel.contractOssKeys[idx] = newKey
        })
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        if (_key.indexOf('http') === 0) {
          resolve(_key)
        }
        let url = ''
        // let ossKey = window.encodeURIComponent(window.btoa(_key))
        let ossKey = window.btoa(_key)
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
    edit () {
      this.$router.push({path: '/guarantees/new/' + this.guaranteeModel.orderNumber})
    },
    async remove () {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该保函记录么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.Guarantee.deleteGuarantee(this.$route.params.orderNumber).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          this.$router.push('/guarantees/list')
        },
        onCancel: () => {
        }
      })
    },
    async revokePdf () {
      this.$Modal.confirm({
        title: '确认操作',
        render: (h) => {
          return h('div', {}, [
            h('p', {}, '确认撤销该电子保函么？')
          ])
        },
        onOk: () => {
          this.loading = true
          this.dataToSign = JSON.stringify({
            orderNumber: this.$route.params.orderNumber
          })
          this.signMode = 'normal'
          this.signCallback = this.doRevokePdf
          this.showCertSelectModal = true
        }
      })
    },
    async doRevokePdf (certSigned) {
      this.$Spin.show()
      await this.$Api.Guarantee.revokePdf(this.$route.params.orderNumber, certSigned)
      .then(() => {
        this.$Message.success('操作成功!')
        this.$Spin.hide()
        this.pdfUrl = null
        this.loading = false
      })
      .catch(err => {
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
        this.$Spin.hide()
        this.loading = false
      })
    },
    async certSigned (certSigned, callback) {
      console.log(certSigned)
      if (callback) {
        callback(certSigned)
      }
    },
    startSign (templateId) {
      this.generatePdf(templateId)
    },
    async generatePdf (templateId) {
      if (!templateId) {
        this.$Notice.error({
          title: '操作失败!',
          desc: '请选择保函模板'
        })
        return false
      }
      this.$Spin.show()
      await this.$Api.Guarantee.generateGuarantee(templateId, this.$route.params.orderNumber).catch(err => {
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
        this.$Spin.hide()
      })
      this.pdfId = await this.$Api.Guarantee.startRemoteSign(this.$route.params.orderNumber).catch(err => {
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
        this.$Spin.hide()
      })
      let plainText = await this.$Api.Guarantee.getPlainText(this.pdfId).catch(err => {
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
        this.$Spin.hide()
      })
      this.$Spin.hide()
      this.dataToSign = plainText
      this.signMode = 'bin'
      this.signCallback = this.setCipherText
      this.showCertSelectModal = true
    },
    async setCipherText (certSigned) {
      console.log(certSigned)
      this.$Spin.show()
      await this.$Api.Guarantee.setCipherText({
        pdfId: this.pdfId,
        cipherText: certSigned.sign
      }).then(() => {
        // console.log(payload)
        this.$Message.success('签名成功!')
        this.loading = false
        this.$Spin.hide()
        this.getGuaranteeDetail()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '签名失败!',
          desc: err.message
        })
      })
    },
    async getPdfUrl () {
      await this.$Api.Guarantee.getPdfDownloadUrl(this.$route.params.orderNumber)
      .then((res) => {
        this.pdfUrl = res
      })
    },
    download () {
      if (this.pdfUrl) {
        window.open(this.pdfUrl, '_blank')
      }
    },
    async checkViewPermission () {
      await this.$Api.Guarantee.checkViewPermission(this.$route.params.orderNumber)
      .then((res) => {
        this.permitted = res
      })
    },
    async getSupervisionPermission () {
      await this.$Api.Guarantee.getSupervisionPermission(this.$route.params.orderNumber)
      .then((res) => {
        console.log(res)
        Object.assign(this.supvPerms, res)
      })
      .catch(() => {
        this.supvPerms = {
          canAudit: false,
          canPreAudit: false,
          canAuditTerminate: false,
          canAuditRenewal: false,
          canClaim: false
        }
      })
    },
    auditPass () {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认审核保函么？</p>',
        onOk: async () => {
          this.loading = true
          let auditNeedSign = this.getSysConfig('AUDIT_GUARANTEE_NEED_SIGN')
          if (auditNeedSign) {
            this.dataToSign = JSON.stringify({
              orderNumber: this.$route.params.orderNumber,
              pass: true,
              reason: null
            })
            this.signMode = 'normal'
            this.signCallback = this.doAuditGuarantee
            this.showCertSelectModal = true
          } else {
            this.dataToSign = {
              orderNumber: this.$route.params.orderNumber,
              pass: true,
              reason: null
            }
            this.doAuditGuarantee(this.dataToSign, false)
          }
          
        }
      })
    },
    async doAuditGuarantee (certSigned, needSign = true) {
      if (needSign) {
        await this.$Api.Guarantee.auditGuarantee(this.$route.params.orderNumber, certSigned)
        .then(() => {
          // console.log(payload)
          this.$Message.success('操作成功!')
          this.loading = false
          this.$Spin.hide()
          this.getGuaranteeDetail()
        })
        .catch(err => {
          this.loading = false
          this.$Spin.hide()
          this.$Notice.error({
            title: '操作失败!',
            desc: err.message
          })
        })
      } else {
        await this.$Api.Guarantee.auditGuaranteeNoSign(this.$route.params.orderNumber, certSigned)
        .then(() => {
          // console.log(payload)
          this.$Message.success('操作成功!')
          this.loading = false
          this.$Spin.hide()
          this.getGuaranteeDetail()
        })
        .catch(err => {
          this.loading = false
          this.$Spin.hide()
          this.$Notice.error({
            title: '操作失败!',
            desc: err.message
          })
        })
      }
    },
    preAuditPass () {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认预审通过保函么？</p>',
        onOk: async () => {
          this.loading = true
          let preAuditNeedSign = this.getSysConfig('PREAUDIT_GUARANTEE_NEED_SIGN')
          if (preAuditNeedSign) {
            this.dataToSign = JSON.stringify({
              orderNumber: this.$route.params.orderNumber,
              pass: true,
              reason: null
            })
            this.signMode = 'normal'
            this.signCallback = this.doPreAuditGuarantee
            this.showCertSelectModal = true
          } else {
            this.dataToSign = {
              orderNumber: this.$route.params.orderNumber,
              pass: true,
              reason: null
            }
            this.doPreAuditGuarantee(this.dataToSign, false)
          }
        }
      })
    },
    async doPreAuditGuarantee (certSigned, needSign = true) {
      if (needSign) {
        await this.$Api.Guarantee.preAuditGuarantee(this.$route.params.orderNumber, certSigned)
        .then(() => {
          // console.log(payload)
          this.$Message.success('操作成功!')
          this.loading = false
          this.$Spin.hide()
          this.getGuaranteeDetail()
        })
        .catch(err => {
          this.loading = false
          this.$Spin.hide()
          this.$Notice.error({
            title: '操作失败!',
            desc: err.message
          })
        })
      } else {
        await this.$Api.Guarantee.preAuditGuaranteeNoSign(this.$route.params.orderNumber, certSigned)
        .then(() => {
          // console.log(payload)
          this.$Message.success('操作成功!')
          this.loading = false
          this.$Spin.hide()
          this.getGuaranteeDetail()
        })
        .catch(err => {
          this.loading = false
          this.$Spin.hide()
          this.$Notice.error({
            title: '操作失败!',
            desc: err.message
          })
        })
      }
    },
    auditDeny () {
      this.$Modal.confirm({
        title: '确认操作',
        render: (h) => {
          return h('div', {}, [
            h('p', {}, '确认退回该保函么？请填写原因后提交'),
            h('Input', {
                props: {
                  value: this.auditModel.reason,
                  autofocus: true,
                  placeholder: '填写退回的原因',
                  type: 'textarea',
                  autosize: {minRows: 5, maxRows: 10},
                  rows: 5
                },
                on: {
                  input: (val) => {
                    this.auditModel.reason = val
                  }
                }
              }
            )
          ])
        },
        onOk: async () => {
          if (!this.auditModel.reason) {
            this.$Notice.error({
              title: '操作失败!',
              desc: '请填写退回原因'
            })
            return false
          }
          this.loading = true
          let auditNeedSign = this.getSysConfig('AUDIT_GUARANTEE_NEED_SIGN')
          if (auditNeedSign) {
            this.dataToSign = JSON.stringify({
              orderNumber: this.$route.params.orderNumber,
              pass: false,
              reason: this.auditModel.reason
            })
            this.signMode = 'normal'
            this.signCallback = this.doAuditGuarantee
            this.showCertSelectModal = true
          } else {
            this.dataToSign = {
              orderNumber: this.$route.params.orderNumber,
              pass: false,
              reason: this.auditModel.reason
            }
            this.doAuditGuarantee(this.dataToSign, false)
          }
        }
      })
    },
    preAuditDeny () {
      this.$Modal.confirm({
        title: '确认操作',
        render: (h) => {
          return h('div', {}, [
            h('p', {}, '确认退回该保函么？请填写原因后提交'),
            h('Input', {
                props: {
                  value: this.auditModel.reason,
                  autofocus: true,
                  placeholder: '填写退回的原因',
                  type: 'textarea',
                  autosize: {minRows: 5, maxRows: 10},
                  rows: 5
                },
                on: {
                  input: (val) => {
                    this.auditModel.reason = val
                  }
                }
              }
            )
          ])
        },
        onOk: async () => {
          if (!this.auditModel.reason) {
            this.$Notice.error({
              title: '操作失败!',
              desc: '请填写退回原因'
            })
            return false
          }
          this.loading = true
          let preAuditNeedSign = this.getSysConfig('PREAUDIT_GUARANTEE_NEED_SIGN')
          if (preAuditNeedSign) {
            this.dataToSign = JSON.stringify({
              orderNumber: this.$route.params.orderNumber,
              pass: false,
              reason: this.auditModel.reason
            })
            this.signMode = 'normal'
            this.signCallback = this.doPreAuditGuarantee
            this.showCertSelectModal = true
          } else {
            this.dataToSign = {
              orderNumber: this.$route.params.orderNumber,
              pass: false,
              reason: this.auditModel.reason
            }
            this.doPreAuditGuarantee(this.dataToSign, false)
          }
        }
      })
    },
    auditTerminatePass () {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认通过保函解除申请么？</p>',
        onOk: async () => {
          this.loading = true
          let auditTerminateNeedSign = this.getSysConfig('AUDIT_TERMINATE_NEED_SIGN')
          if (auditTerminateNeedSign) {
            this.dataToSign = JSON.stringify({
              orderNumber: this.$route.params.orderNumber,
              pass: true,
              reason: null
            })
            this.signMode = 'normal'
            this.signCallback = this.doAuditTerminate
            this.showCertSelectModal = true
          } else {
            this.dataToSign = {
              orderNumber: this.$route.params.orderNumber,
              pass: true,
              reason: null
            }
            this.doAuditTerminate(this.dataToSign, false)
          }
        }
      })
    },
    auditTerminateDeny () {
      this.$Modal.confirm({
        title: '确认操作',
        render: (h) => {
          return h('div', {}, [
            h('p', {}, '确认退回审核解除该保函么？请填写原因后提交'),
            h('Input', {
                props: {
                  value: this.auditModel.reason,
                  autofocus: true,
                  placeholder: '填写退回解除保函的原因'
                },
                on: {
                  input: (val) => {
                    this.auditModel.reason = val
                  }
                }
              }
            )
          ])
        },
        onOk: async () => {
          if (!this.auditModel.reason) {
            this.$Notice.error({
              title: '操作失败!',
              desc: '请填写解除原因'
            })
            return false
          }
          this.loading = true
          let auditTerminateNeedSign = this.getSysConfig('AUDIT_TERMINATE_NEED_SIGN')
          if (auditTerminateNeedSign) {
            this.dataToSign = JSON.stringify({
              orderNumber: this.$route.params.orderNumber,
              pass: false,
              reason: this.auditModel.reason
            })
            this.signMode = 'normal'
            this.signCallback = this.doAuditTerminate
            this.showCertSelectModal = true
          } else {
            this.dataToSign = {
              orderNumber: this.$route.params.orderNumber,
              pass: false,
              reason: this.auditModel.reason
            }
            this.doAuditTerminate(this.dataToSign, false)
          }
        }
      })
    },
    async doAuditTerminate (certSigned, needSign = true) {
      if (needSign) {
        await this.$Api.Guarantee.auditTerminate(this.$route.params.orderNumber, certSigned)
        .then(() => {
          // console.log(payload)
          this.$Message.success('操作成功!')
          this.loading = false
          this.$Spin.hide()
          this.getGuaranteeDetail()
        })
        .catch(err => {
          this.loading = false
          this.$Spin.hide()
          this.$Notice.error({
            title: '操作失败!',
            desc: err.message
          })
        })
      } else {
        await this.$Api.Guarantee.auditTerminateNoSign(this.$route.params.orderNumber, certSigned)
        .then(() => {
          // console.log(payload)
          this.$Message.success('操作成功!')
          this.loading = false
          this.$Spin.hide()
          this.getGuaranteeDetail()
        })
        .catch(err => {
          this.loading = false
          this.$Spin.hide()
          this.$Notice.error({
            title: '操作失败!',
            desc: err.message
          })
        })
      }
    },
    terminate () {
      this.terminateModel.orderNumber = this.$route.params.orderNumber
      this.terminateModal = true
      this.uploadList = this.$refs.reportUploader.fileList
    },
    auditRenewalPass (tid) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认通过保函续保申请么？</p>',
        onOk: async () => {
          this.loading = true
          let needSign = this.getSysConfig('AUDIT_RENEWAL_NEED_SIGN')
          if (needSign) {
            this.dataToSign = JSON.stringify({
              tid: tid,
              auditPass: true,
              auditReason: null
            })
            this.signMode = 'normal'
            this.signCallback = this.doAuditRenewal
            this.showCertSelectModal = true
          } else {
            this.dataToSign = {
              tid: tid,
              auditPass: true,
              auditReason: null
            }
            this.doAuditRenewal(this.dataToSign, false)
          }
        }
      })
    },
    auditRenewalDeny (tid) {
      this.$Modal.confirm({
        title: '确认操作',
        render: (h) => {
          return h('div', {}, [
            h('p', {}, '确认拒绝该保函的续保申请么？请填写原因后提交'),
            h('Input', {
                props: {
                  value: this.auditModel.reason,
                  autofocus: true,
                  placeholder: '填写拒绝的原因'
                },
                on: {
                  input: (val) => {
                    this.auditModel.reason = val
                  }
                }
              }
            )
          ])
        },
        onOk: async () => {
          if (!this.auditModel.reason) {
            this.$Notice.error({
              title: '操作失败!',
              desc: '请填写原因'
            })
            return false
          }
          this.loading = true
          let needSign = this.getSysConfig('AUDIT_RENEWAL_NEED_SIGN')
          if (needSign) {
            this.dataToSign = JSON.stringify({
              tid: tid,
              auditPass: false,
              auditReason: this.auditModel.reason
            })
            this.signMode = 'normal'
            this.signCallback = this.doAuditRenewal
            this.showCertSelectModal = true
          } else {
            this.dataToSign = {
              tid: tid,
              auditPass: false,
              auditReason: this.auditModel.reason
            }
            this.doAuditRenewal(this.dataToSign, false)
          }
        }
      })
    },
    async doAuditRenewal (certSigned, needSign = true) {
      if (needSign) {
        await Api.Guarantee.auditGuaranteeRenewal(certSigned)
        .then(() => {
          // console.log(payload)
          this.$Message.success('操作成功!')
          this.loading = false
          this.$Spin.hide()
          this.getGuaranteeDetail()
        })
        .catch(err => {
          this.loading = false
          this.$Spin.hide()
          this.$Notice.error({
            title: '操作失败!',
            desc: err.message
          })
        })
      } else {
        await Api.Guarantee.auditGuaranteeRenewalNoSign(certSigned)
        .then(() => {
          // console.log(payload)
          this.$Message.success('操作成功!')
          this.loading = false
          this.$Spin.hide()
          this.getGuaranteeDetail()
        })
        .catch(err => {
          this.loading = false
          this.$Spin.hide()
          this.$Notice.error({
            title: '操作失败!',
            desc: err.message
          })
        })
      }
    },
    selectReason (idx) {
      if (this.selectedReasonIdx === idx) {
        this.selectedReasonIdx = null
        this.terminateModel.reason = null
      } else {
        this.selectedReasonIdx = idx
        this.terminateModel.reason = this.terminateReasons[idx]
      }
    },
    async doTerminateGuarantee () {
      this.$refs['terminateForm'].validate((valid) => {
        if (valid) {
          this.terminateModel.reportOssKeys = this.terminateModel.reportOssKeys.map((r) => {
            return r.name
          })
          let needSign = this.getSysConfig('TERMINATE_NEED_SIGN')
          if (needSign) {
            this.dataToSign = JSON.stringify(this.terminateModel)
            this.signMode = 'normal'
            this.signCallback = this.submitTerminateGuarantee
            this.showCertSelectModal = true
          } else {
            this.dataToSign = this.terminateModel
            this.submitTerminateGuarantee(this.dataToSign, false)
          }
        }
      })
    },
    async submitTerminateGuarantee (certSigned, needSign = true) {
      this.loading = true
      if (needSign) {
        await this.$Api.Guarantee.terminate(this.$route.params.orderNumber, certSigned)
        .then(() => {
          // console.log(payload)
          this.$Message.success('操作成功!')
          this.loading = false
          this.$Spin.hide()
          this.getGuaranteeDetail()
          this.closeTerminateModal()
        })
        .catch(err => {
          this.loading = false
          this.$Spin.hide()
          this.$Notice.error({
            title: '操作失败!',
            desc: err.message
          })
        })
      } else {
        await this.$Api.Guarantee.terminateNoSign(this.$route.params.orderNumber, certSigned)
        .then(() => {
          // console.log(payload)
          this.$Message.success('操作成功!')
          this.loading = false
          this.$Spin.hide()
          this.getGuaranteeDetail()
          this.closeTerminateModal()
        })
        .catch(err => {
          this.loading = false
          this.$Spin.hide()
          this.$Notice.error({
            title: '操作失败!',
            desc: err.message
          })
        })
      }
    },
    closeTerminateModal () {
      this.terminateModal = false
      this.terminateModel = {
        orderNumber: null,
        reason: null,
        reportOssKeys: []
      }
    },
    getOSSParams (index) {
      this.$Api.Guarantee.getUploadParams(2).then((res) => {
        this.uploadParams = {
          accessid: res.accessid,
          host: res.host,
          policy: res.policy,
          signature: res.signature,
          callbackbody: res.callbackbody,
          key: res.dir,
          expire: res.expire
        }
        this.uploadParams.host = this.uploadParams.host.replace('-internal', '')
        this.curOSSParamIndex = index    // 上传控件序号
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    procReportOssKeys (keys) {
      if (!keys || !(keys instanceof Array)) {
        return false
      }
      keys.forEach(async (k) => {
        try {
          if (typeof(k) === 'string') {
            let keyObj = await this.procOssKey(k)
            this.uploadedReportArray.push(keyObj)
            this.$nextTick(() => {
              this.uploadList = this.$refs.reportUploader.fileList
            })
          } else if (typeof(k) === 'object' && k.url) {
            this.uploadedReportArray.push({
              name: k.name,
              url: k.url,
              type: k.type,
              surfix: k.prefix
            })
            this.$nextTick(() => {
              this.uploadList = this.$refs.reportUploader.fileList
            })
          }
        } catch (e) {
          console.log(e)
        }
      })
    },
    removeItem (item) {
      let idx = this.uploadList.findIndex(o => o.name === item.name)
      this.uploadList.splice(idx, 1)
    },
    handleBeforeUpload (file) {
      let filename = this.uploadParams.key + this.randomString(10) + this.getSuffix(file.name)
      this.OSSParams[this.curOSSParamIndex] = {
        name: file.name,
        key: filename,
        policy: this.uploadParams.policy,
        OSSAccessKeyId: this.uploadParams.accessid,
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: this.uploadParams.signature,
        fileIndex: this.curOSSParamIndex
      }
      this.OSSParam.name = file.name
      this.OSSParam.key = filename
      this.OSSParam.policy = this.uploadParams.policy
      this.OSSParam.OSSAccessKeyId = this.uploadParams.accessid
      this.OSSParam.success_action_status = '200'   // 让服务端返回200,不然，默认会返回204
      this.OSSParam.signature = this.uploadParams.signature
      this.OSSParam.fileIndex = this.curOSSParamIndex
    },
    async handleUploadSuccess (response, file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      let ossParam = this.OSSParams.filter((item) => {
        return item.name === file.name
      })[0]
      let filename = 'oss:' + ossParam.key
      file.name = filename
      let keyObj = await this.procOssKey(filename)
      this.$nextTick(() => {
        console.log(keyObj.url)
        file.url = keyObj.url
        this.terminateModel.reportOssKeys.push(file)
        this.$refs['terminateForm'].validate()
      })
    },
    handleFormatError () {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '上传文件格式不正确。'
      })
    },
    randomString (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    getSuffix (filename) {
      let pos = filename.lastIndexOf('.')
      let suffix = ''
      if (pos !== -1) {
        suffix = filename.substring(pos)
      }
      return suffix
    },
    smsVerifySumbit (model) {
      let mobile = model.mobile
      let code = model.code
      console.log(mobile, code)
      this.showSmsVerify = false
    },
    handleImgPreview (list, index) {
      this.imageUrls = list.map((l) => {return l.url})
      this.visiblePreviewer = true
      this.startPosition = index
    },
    renewSubmitted () {
      this.showRenewalModal = false
      this.getGuaranteeDetail()
    },
    goToClaim () {
      this.$router.push('/claims/add/' + this.$route.params.orderNumber)
    },
    showGuaReceipt () {
      this.showReceiptModal = true
    }
  }
}
</script>

<style lang="less">
// @primary-color: #3855b8;
.guarantee-detail {
  height: 100%;
  .detail-header {
    margin-bottom: 20px;
    position: relative;
    .status-badge {
      position: absolute;
      right: 0;
      top: 0;
    }
    .header-actions {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }
  }
  .brief-table {
    td.title {
      width: 148px;
    }
    .joint-plan {
      padding-left: 15px;
    }
  }
  .contract {
    display: flex;
    flex-direction: row;
    margin: 10px 0;
  }
  .contract-thumb {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-color: #efefef;
    width: 100px;
    height: 100px;
    margin-right: 4px;
    transition: all .2s ease-in-out;
    padding: 3px;
    border: 1px solid #d2d2d2;
    position: relative;
    &:hover {
      border: 1px solid rgb(65,157,253);
      background-color: #fff;
    }
    overflow: hidden;
    img {
      cursor: pointer;
      width: 100%;
    }
    .contract-thumb-cover{
      opacity: 0;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0,0,0,.6);
      transition: all .3s linear;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
    &:hover .contract-thumb-cover{
      opacity: 1;
    }
    .contract-thumb-cover i{
      color: #fff;
      font-size: 20px;
      cursor: pointer;
      margin: 0 5px;
    }
  }
}
.reasons {
  margin-bottom: 10px;
  .reason-selection {
    display: inline-block;
    padding: 3px 5px;
    border: 1px solid #e2e2e2;
    border-radius: 2px;
    transition: all .2s ease-in-out;
    margin-right: 5px;
    line-height: 18px;
    background: #f2f2f2;
    cursor: pointer;
    &:hover {
      background: #fff;
      border: 1px solid @primaryColor;
    }
    &.selected {
      background: #fff;
      border: 1px solid @primaryColor;
    }
  }
}
</style>
